import React from "react"
import { SadIcon } from "../../common/Icons"
import "./Cancelled.css"

export default function({ status }) {
  return (
    <div className="Cancelled">
      <SadIcon />
      {(status === "cancelled" && (
        <>
          <h1>Your order has been cancelled</h1>
          <p>
            Your order has been cancelled. If you think this was done in error
            or if you wish to order again, please contact the seller.
          </p>
        </>
      )) || (
        <>
          <h1>Your order has expired</h1>
          <p>
            We're sorry, your order has expired. But don't worry, you can simply
            order again.
          </p>
        </>
      )}
    </div>
  )
}
